module.exports = __webpack_public_path__ + "img/ident.6a588b57.jpg";